export default "__VITE_ASSET__DUYg9pJB__"